module.exports = __webpack_public_path__ + "media/app/assets/races/draenei_male-18a2336abe10e5e47c7fb8ef90210902.png";